<div *ngIf="ukon?.souladSPdInfo">
  <span [class]="ukon.souladSPdInfo.stav"><i [class]="getIconClass(ukon.souladSPdInfo.stav)"></i></span>
  <span class="pl-10">{{ ukon.odeslanVeVerziPd.cisloVerze }}</span>
</div>
